import {
  checkHttpStatus,
  getApiBaseUrlWithOrg,
  getApiHeaders
} from '../utils/api'
import {
  fetchUnreadAssessmentCountFailure,
  fetchUnreadAssessmentCountRequest,
  fetchUnreadAssessmentCountSuccess
} from './myartifacts'

export const SET_UNREAD_ANNOUNCEMENT_COUNT = 'SET_UNREAD_ANNOUNCEMENT_COUNT'
export const TOGGLE_STUDENT_ANNOUNCEMENTS_SIDEBAR =
  'TOGGLE_STUDENT_ANNOUNCEMENTS_SIDEBAR'
export const CLEAR_ANNOUNCEMENT_NOTIFICATION_ID =
  'CLEAR_ANNOUNCEMENT_NOTIFICATION_ID'

export function clearAnnouncementNotificationId() {
  return {
    type: CLEAR_ANNOUNCEMENT_NOTIFICATION_ID
  }
}

export function setUnreadAnnouncementCount(count) {
  return {
    type: SET_UNREAD_ANNOUNCEMENT_COUNT,
    payload: {
      count
    }
  }
}

export function toggleStudentAnnouncementsSidebar(display, notificationId) {
  return {
    type: TOGGLE_STUDENT_ANNOUNCEMENTS_SIDEBAR,
    payload: {
      display,
      notificationId
    }
  }
}

export const fetchUnreadAnnouncementsCount = () => {
  return async (dispatch, getState) => {
    const state = getState()

    try {
      const url = `${getApiBaseUrlWithOrg(
        state.organization.orgId
      )}/user/course_section_announcements/unread_count`

      const response = checkHttpStatus(
        await fetch(url, {
          method: 'GET',
          headers: getApiHeaders(state)
        })
      )

      const data = await response.json()
      dispatch(toggleStudentAnnouncementsSidebar(false))
      dispatch(setUnreadAnnouncementCount(data.unread_count))
    } catch (error) {}
  }
}
